// @ts-check

/**
 * B2B platform API surface.
 *
 * Every B2B service is mounted on the customer host behind its own slug — the
 * edge Gateway denies anything outside this list before routing, so a wrong
 * prefix comes back as `403`, never `404`. Verified against the stage Gateway
 * on 2026-08-12; see TwistoPayments/devops.docs `plans/b2b-platform-links.md`
 * and `plans/b2b-api-swagger-quick-reference.md`.
 *
 * Swagger/ReDoc/OpenAPI documents are NOT on this host — they are served from
 * the staff host (`api-admin-pro.*`)
 */
const B2B_API_PATHS = {
  balance: '/balance/api/v1',
  cards: '/cards/api/v1',
  fx: '/fx/api/v1',
  /** tokenless, GET/POST only */
  identityGate: '/identity/api/v1/gate',
  onboarding: '/onboarding/api/v1',
  /** tokenless, GET/POST only */
  openBankingGate: '/open-banking/api/v1/gate',
  /**
   * Routed but not yet in the edge allow-list — every call, including
   * `OPTIONS`, returns `403` until DevOps lands the path class in
   * `authn-policies.yaml`. The prefix itself is correct; do not work around it
   * by changing the URL.
   */
  users: '/users/api/v1',
}

/**
 * Absolute B2B endpoints for one environment.
 *
 * Pass the environment's own settings — `stageSettings`, `productionSettings`
 * — so callers never rebuild these URLs by hand.
 *
 * @param {{ B2B_API_ENDPOINT: string }} settings
 */
const getB2bApiUrls = ({ B2B_API_ENDPOINT }) => ({
  BALANCE_API_ENDPOINT: `${B2B_API_ENDPOINT}${B2B_API_PATHS.balance}`,
  CARDS_API_ENDPOINT: `${B2B_API_ENDPOINT}${B2B_API_PATHS.cards}`,
  FX_API_ENDPOINT: `${B2B_API_ENDPOINT}${B2B_API_PATHS.fx}`,
  IDENTITY_GATE_ENDPOINT: `${B2B_API_ENDPOINT}${B2B_API_PATHS.identityGate}`,
  ONBOARDING_API_ENDPOINT: `${B2B_API_ENDPOINT}${B2B_API_PATHS.onboarding}`,
  OPEN_BANKING_GATE_ENDPOINT: `${B2B_API_ENDPOINT}${B2B_API_PATHS.openBankingGate}`,
  USERS_API_ENDPOINT: `${B2B_API_ENDPOINT}${B2B_API_PATHS.users}`,
})

module.exports = {
  B2B_API_PATHS,
  getB2bApiUrls,
}
